import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function cadastrialValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const regex = /^[0-9:\/]+$/;

    const valid = regex.test(control.value);
    return valid
      ? null
      : {
          pattern: {
            actualValue: control.value,
            requiredPattern: "0-9, :, /.",
          },
        };
  };
}
